import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import '../../index.css';

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { BetService } from './BetService';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import useToken from '../App/useToken';
import { classNames } from 'primereact/utils';
import { InputNumber } from 'primereact/inputnumber';
import SpecialPredictions from '../SpecialPredictions/SpecialPredictions';
import '../UserResponsive.css';

function App( visit) {
    return (
        <div>
            <DataTableCrudDemo visit={visit.visit} />
        </div>
    );
}

const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return { date: '-', time: '' };

    const [datePart, timePart] = dateTimeStr.split(' ');
    if (!timePart) return { date: datePart, time: '' };

    const [hoursStr, minutesStr] = timePart.split(':');
    let hour = parseInt(hoursStr, 10);
    const ampm = hour >= 12 ? 'pm' : 'am';
    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    return { date: datePart, time: `${hour}:${minutesStr} ${ampm}` };
}

const dateTimeBodyTemplate = (field) => (rowData) => {
    if (rowData.resumen_bloqueado) {
        return <span className="summary-lock-message">Bloqueado</span>;
    }

    const { date, time } = formatDateTime(rowData[field]);

    return (
        <div className="date-time-cell">
            <span className="date-part">{date}</span>
            <span className="time-part">{time}</span>
        </div>
    );
}

const DataTableCrudDemo = ( visit ) => {

    let emptyProduct = {
        partido_id: "",
        teamlGoles: "",
        teamvGoles: "",
    };

    const [products, setProducts] = useState(null);
    const [puntajeTotal, setPuntajeTotal] = useState(0);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const betService = new BetService();
    const { token } = useToken();
    const [nombreEquipoLocal, setnombreEquipoLocal] = useState(null);
    const [nombreEquipoVisitante, setnombreEquipoVisitante] = useState(null);
    const [nombreUsuario, setNombreUsuario] = useState(null);
    const [columnAgregarResultados, setColumnAgregarResultados] = useState("none");

    useEffect(() => {
        if (visit.visit == 0){
            betService.getPartidosList(token).then(data => {
                setProducts(sortMyBets(data))
                setColumnAgregarResultados("block");
            });

            betService.getPuntajeTotal(token, visit.visit).then(data => {
                //console.log(data);
                setPuntajeTotal(data['puntajeTotal'])
                setNombreUsuario(data['usuario']);
            });
    

        }
        else
        {
            betService.getPartidosUser(token, visit.visit).then(data => {
                setProducts(data)
                setColumnAgregarResultados("none");
            });

            betService.getPuntajeTotal(token, visit.visit).then(data => {
                //console.log(data);
                setPuntajeTotal(data['puntajeTotal'])
                setNombreUsuario(data['usuario']);
            });
    

        }

    }, [visit.visit, token]);

    const sortMyBets = (bets) => {
        return (bets || []).map((bet, index) => ({ ...bet, originalIndex: index })).sort((a, b) => {
            const aIsPlayoff = isPlayoff(a);
            const bIsPlayoff = isPlayoff(b);

            if (aIsPlayoff && !bIsPlayoff) {
                return -1;
            }

            if (!aIsPlayoff && bIsPlayoff) {
                return 1;
            }

            if (aIsPlayoff && bIsPlayoff) {
                return parseMatchDate(b.fechaPartido) - parseMatchDate(a.fechaPartido);
            }

            return a.originalIndex - b.originalIndex;
        });
    }

    const parseMatchDate = (value) => {
        const timestamp = new Date((value || '').replace(' ', 'T')).getTime();
        return Number.isNaN(timestamp) ? 0 : timestamp;
    }

    const isPlayoff = (rowData) => {
        return String(rowData?.fase || '').trim().toLowerCase().includes('playoff');
    }

    const hasOfficialResult = (rowData) => {
        return rowData?.resultado_cargado || (rowData?.resultadoTeamlGoles !== null && rowData?.resultadoTeamlGoles !== undefined && rowData?.resultadoTeamvGoles !== null && rowData?.resultadoTeamvGoles !== undefined);
    }

    const hasUserBet = (rowData) => {
        return rowData?.teamlGoles !== null && rowData?.teamlGoles !== undefined && rowData?.teamvGoles !== null && rowData?.teamvGoles !== undefined;
    }

    const openNew = (e) => {
        setProduct(emptyProduct);
        setSubmitted(false);
        let _product = {...product};
        _product['partido_id'] = e.id;
        _product['teamlGoles'] = e.teamlGoles !== null && e.teamlGoles !== undefined ? e.teamlGoles : "0";
        _product['teamvGoles'] = e.teamvGoles !== null && e.teamvGoles !== undefined ? e.teamvGoles : "0";
        setnombreEquipoLocal(e.equipoLocal);
        setnombreEquipoVisitante(e.equipoVisitante);
        setProduct(_product);
        setProductDialog(true);
        //console.log(_product);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
        setProduct(emptyProduct);
    }

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    }

    const hideDeleteProductsDialog = () => {
        setDeleteProductsDialog(false);
    }

    const saveProduct = async e => {
        setSubmitted(true);        
        let _products = [...products];
        let _product = {...product};
        if (_product.partido_id === "" || _product.teamlGoles === "" || _product.teamvGoles === "" ){
            toast.current.show({ severity: 'error', summary: 'Errores', detail: 'Llenar todos los datos!!', life: 3000 });
        }
        else{
            if (product.id) {
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Updated', life: 3000 });
            }
            else {
                let teamlGoles = _product.teamlGoles;
                let teamvGoles = _product.teamvGoles;
                let partido_id = _product.partido_id;
                const newTeamResponse = await betService.newMatch({
                    teamlGoles,
                    teamvGoles,
                    partido_id,
                },token);
                if ( newTeamResponse.code === 200){
                    betService.getPartidosList(token).then(data => setProducts(sortMyBets(data)));
                    betService.getPuntajeTotal(token, visit.visit).then(data => {
                        setPuntajeTotal(data['puntajeTotal'])
                        setNombreUsuario(data['usuario']);
                    });
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Apuesta Grabada', life: 3000 });
                }
                else{
                    toast.current.show({ severity: 'error', summary: 'Error al crear la apuesta', detail: newTeamResponse.mensaje, life: 3000 });
                }
                _products.push(_product);
            }
                //setProducts(_products);
            setProductDialog(false);
            setProduct(emptyProduct);
        }
    }

    // const editProduct = (product) => {
    //     setProduct({...product});
    //     setProductDialog(true);
    // }

    // const confirmDeleteProduct = (product) => {
    //     setProduct(product);
    //     setDeleteProductDialog(true);
    // }

    const deleteProduct = () => {
        let _products = products.filter(val => val.id !== product.id);
        setProducts(_products);
        setDeleteProductDialog(false);
        setProduct(emptyProduct);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000 });
    }

    const deleteSelectedProducts = () => {
        let _products = products.filter(val => !selectedProducts.includes(val));
        setProducts(_products);
        setDeleteProductsDialog(false);
        setSelectedProducts(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
    }

    const onInputChange = (e, name, rowData) => {
        const val = e.value;//(e.target && e.target.value) || '';
        let _product = {...product};
        _product[`${name}`] = val;
        setProduct(_product);
        //console.log(_product);
    }
    // const onInputChangeDateTime = (e, name) => {
    //     const val = (e.target && e.target.value) || '';
    //     let _product = {...product};
    //     _product[`${name}`] = val;
    //     setProduct(_product);
    // }


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <h5>{nombreUsuario} - Puntos = {puntajeTotal}</h5>
            </React.Fragment>
        )
    }

    const imageBodyTemplate = (rowData) => {
        //let url = 'http://192.168.1.27/public/laraveldocker/public/storage/banderas/'+rowData.banderaEquipoLocal;
        let url = process.env.REACT_APP_URL_IMAGES+rowData.banderaEquipoLocal;
        return (
            <React.Fragment>
                <div className="team-cell">
                <img src={url} 
                    onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
                    alt={rowData.bandera} className="product-image" />
                <span className={`product-badge status-${rowData.equipoLocal.toLowerCase()}`}>{rowData.equipoLocal}</span>
                </div>
            </React.Fragment>
        );
    }

    const actionBodyTemplate = (rowData) => {
        if ( visit.visit == 0 ){
            if (rowData.resultado_cargado) {
                return (
                    <React.Fragment>
                        <Button label="Finalizado" icon="pi pi-check" className="p-button-rounded p-button-success" disabled />
                    </React.Fragment>
                );
            }

            if (!rowData.apuesta_abierta) {
                return (
                    <React.Fragment>
                        <Button label="Cerrada" icon="pi pi-lock" className="p-button-rounded p-button-secondary" disabled />
                    </React.Fragment>
                );
            }

        return (
            <React.Fragment>
                <Button id={rowData.id} label={rowData.partido_id ? 'Cambiar' : 'Apostar'} icon="pi pi-pencil" className="p-button-rounded p-button-info" 
                onClick={ () => openNew(rowData) } />
            </React.Fragment>
        );
        }
    }

    const resultBodyTemplate = (rowData) => {
        if (rowData.resumen_bloqueado) {
            return <span className="summary-lock-message">{rowData.mensaje_bloqueo}</span>;
        }

        if (!rowData.resultado_cargado) {
            return '-';
        }

        return `${rowData.resultadoTeamlGoles} - ${rowData.resultadoTeamvGoles}`;
    }

    const betGoalsBodyTemplate = (field) => (rowData) => {
        if (rowData.resumen_bloqueado) {
            return <span className="summary-lock-message">Bloqueado</span>;
        }

        return rowData[field] !== null && rowData[field] !== undefined ? rowData[field] : '-';
    }

    const pointsBodyTemplate = (rowData) => {
        if (rowData.resumen_bloqueado) {
            return <span className="summary-lock-message">Bloqueado</span>;
        }

        return rowData.puntos !== null && rowData.puntos !== undefined ? rowData.puntos : '-';
    }

    const phaseBodyTemplate = (rowData) => {
        if (isPlayoff(rowData)) {
            return roundLabel(rowData.ronda);
        }

        return 'Fase de grupos';
    }

    const roundLabel = (ronda) => {
        const labels = {
            dieciseisavos: '16avos',
            octavos: '8avos',
            cuartos: '4tos',
            semifinal: 'Semifinal',
            tercer_puesto: 'Tercer puesto',
            final: 'Final',
        };

        return labels[ronda] || 'Playoffs';
    }

    const rowClassName = (rowData) => {
        if (visit.visit != 0 || !isPlayoff(rowData) || hasOfficialResult(rowData)) {
            return {};
        }

        return {
            'playoff-bet-row-complete': hasUserBet(rowData),
            'playoff-bet-row-pending': !hasUserBet(rowData),
        };
    }

    const imageVisitanteBodyTemplate = (rowData) => {
        let url = process.env.REACT_APP_URL_IMAGES+rowData.banderaEquipoVisitante;
        return (
            <React.Fragment>
                <div className="team-cell">
                <img src={url} 
                    onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} 
                    alt={rowData.banderaEquipoVisitante} className="product-image" />
                <span className={`product-badge status-${rowData.equipoVisitante.toLowerCase()}`}>{rowData.equipoVisitante}</span>
                </div>
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="mx-0 my-1">Partidos</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );
    const productDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
        </React.Fragment>
    );
    const deleteProductDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteProduct} />
        </React.Fragment>
    );
    const deleteProductsDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductsDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedProducts} />
        </React.Fragment>
    );



    return (
        <div className="datatable-crud-demo user-mobile-page">
            <Toast ref={toast} />

            {visit.visit == 0 && <SpecialPredictions />}

            <div className="card">
                <Toolbar className="mb-4" left={leftToolbarTemplate} ></Toolbar>

                <DataTable ref={dt} value={products} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                    className="user-mobile-table bets-mobile-table"
                    scrollable
                    tableStyle={{ minWidth: '68rem' }}
                    rowClassName={rowClassName}
                    dataKey="id" paginator rows={20} rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll" scrollDirection="both">
                    {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column> */}
                    <Column field="id" header="id" sortable style={{ minWidth: '1rem' , display:"none" }}></Column>
                    <Column field="equipoLocal" header="Equipo local" body={imageBodyTemplate} sortable className="team-name-col" headerClassName="team-name-col" style={{ width: '9rem', minWidth: '9rem', maxWidth: '9rem' }}></Column>
                    <Column field="teamlGoles" header={<span className="stacked-column-title">Goles<br />local</span>} body={betGoalsBodyTemplate('teamlGoles')} sortable className="goals-col" headerClassName="goals-col" style={{ width: '4rem', minWidth: '4rem', maxWidth: '4rem' }}></Column>
                    <Column field="teamvGoles" header={<span className="stacked-column-title">Goles<br />visitante</span>} body={betGoalsBodyTemplate('teamvGoles')} sortable className="goals-col" headerClassName="goals-col" style={{ width: '4.4rem', minWidth: '4.4rem', maxWidth: '4.4rem' }}></Column>
                    <Column field="equipoVisitante" header="Equipo visitante" body={imageVisitanteBodyTemplate} sortable className="team-name-col" headerClassName="team-name-col" style={{ width: '9rem', minWidth: '9rem', maxWidth: '9rem' }} ></Column>
                    <Column header="Resultado oficial" body={resultBodyTemplate} sortable style={{ minWidth: '6.5rem' }}></Column>
                    <Column field="teaml_id" header="teaml_id" sortable style={{ minWidth: '16rem', display:"none" }}></Column>
                    <Column field="teamv_id" header="teamv_id" sortable style={{ minWidth: '16rem', display:"none" }}></Column>
                    <Column field="puntos" header="Puntos" body={pointsBodyTemplate} sortable style={{ minWidth: '5rem' }}></Column>                    
                    <Column field="action" header="Apuesta" body={actionBodyTemplate} sortable style={{ minWidth: '7.5rem', display:columnAgregarResultados  }}></Column>
                    <Column field="fechaPartido" header="Fecha Partido" body={dateTimeBodyTemplate('fechaPartido')} sortable className="datetime-col" headerClassName="datetime-col" style={{ minWidth: '6.5rem' }}></Column>
                    <Column field="deadline_apuesta" header="Cierre apuesta" body={dateTimeBodyTemplate('deadline_apuesta')} sortable className="datetime-col" headerClassName="datetime-col" style={{ minWidth: '6.5rem' }}></Column>
                    <Column field="fase" header="Fase" body={phaseBodyTemplate} sortable style={{ minWidth: '7rem' }}></Column>
                    {/* <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column> */}
                </DataTable>
            </div>

            <Dialog visible={productDialog} style={{ width: '450px' }} header="Apuesta del partido" modal className="p-fluid bet-dialog" footer={productDialogFooter} onHide={hideDialog}>
                <div className="field">
                    <label htmlFor="teamlGoles">{nombreEquipoLocal}</label>
                        <InputNumber 
                            id="teamlGoles" 
                            value={product.teamlGoles}
                            min={0} max={100} 
                            onChange={(e) => onInputChange(e, 'teamlGoles')} 
                            required autoFocus className={classNames({ 'p-invalid': submitted && !product.teamlGoles })} />
                            {submitted && !product.teamlGoles && <small className="p-error">Los Goles Del Equipo Local Son Requeridos.</small>}
                </div>
                <div className="field">
                    <label htmlFor="teamvGoles">{nombreEquipoVisitante}</label>
                        <InputNumber 
                            id="teamvGoles" 
                            value={product.teamvGoles}
                            min={0} max={100} 
                            onChange={(e) => onInputChange(e, 'teamvGoles')} 
                            required autoFocus className={classNames({ 'p-invalid': submitted && !product.teamvGoles })} />
                            {submitted && !product.teamvGoles && <small className="p-error">Los Goles Del Equipo Visitante Son Requeridos.</small>}
                </div>
            </Dialog>

            <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem'}} />
                    {product && <span>Are you sure you want to delete <b>{product.name}</b>?</span>}
                </div>
            </Dialog>

            <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem'}} />
                    {product && <span>Are you sure you want to delete the selected products?</span>}
                </div>
            </Dialog>
        </div>
    );
}
export default App;
